import HistoryIcon from './HistoryIcon'
import LanguageIcon from './LanguageIcon'
import ParametersIcon from './ParametersIcon'
import TutorialIcon from './TutorialIcon'

export { HistoryIcon, LanguageIcon, ParametersIcon, TutorialIcon }
